import { render, staticRenderFns } from "./BaseBtcTurkIcon.vue?vue&type=template&id=50404db5&scoped=true"
import script from "./BaseBtcTurkIcon.vue?vue&type=script&lang=js"
export * from "./BaseBtcTurkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50404db5",
  null
  
)

export default component.exports